import React, { Component } from 'react';
import Card from '../../Components/Card/bigCard';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios'
import TicketReservated from '../../Components/Ticket/ticketReservated'
import NumberFormat from 'react-number-format';
import Cookies from 'universal-cookie';
import moment from 'moment';

const cookies = new Cookies();
// Components
// Styling
const getState = (state) => {
    return {
        currentEvent: state.currentEvent,
        url: state.url,
    }
}

const Dispatch = (dispatch) => {
    return {}
}
class ThankYou extends Component {
    constructor() {
        super()
        this.state = {
            seats: [],
            event: {
                name: '',
                date: ''
            },
        }
    }
    componentWillMount = () => {
        let reservation = ''
        let user = cookies.get('key')
        let url = this.props.url
        axios.get(url + '/api/v1/reservations/lastreservation/?user=' + user)
            .then(response => {
                console.log(response.data)
                reservation = response.data[0]
                this.setState({ reservation: reservation, event: reservation.event })
                axios.get(url + '/api/v1/reservations/lastseatsreservated/?reservation=' + reservation.id)
                    .then(response2 => {
                        console.log(response2.data)
                        this.setState({ seats: response2.data })
                    })
                    .catch(err => {
                        console.log(err)
                    })
            })
            .catch(err => {
                console.log(err)
            })
    }

    render() {
        return (
            <div className="container pt-6">
                <Card>
                    <div className="d-inline back">
                        <Link to='/' className="back-btn"><i className="fa fa-caret-left"></i> Atrás</Link>
                    </div>
                    <div className="offset-sm-1 col-sm-10 text-center">
                        <h5 class=" strong p-4"><span class="d-block" style={{fontSize:'3.2rem'}}>🎉</span> ¡Nos vemos en el evento!</h5>
                        <p>Acabas de comprar para <strong>"{this.state.event.name}"</strong> para este próximo <strong>{moment(this.state.event.date).format("DD-MM-YYYY")}.</strong></p>
                        <p>Que la fiesta empieze desde ahora, comparte  con tus amigos la noticia de que vas para el evento.</p>
                        <p>Confirma a continuación las taquillas que acabas de comprar para este grandioso evento.</p>
                        <h5 className="title-green strong pt-4">ASIENTOS ADQUIRIDOS</h5>
                        <div className="map-container pt-6">
                            <div className="row">
                                <div className="col-10 offset-1">
                                    {this.state.seats.map((el, key) => {
                                        let price = 0;
                                        price = <NumberFormat thousandSeparator={true} displayType={'text'} value={el.price} />

                                        return <TicketReservated key={key}
                                            ticketName={"Sección " + el.ticket_name.name}
                                            seat={el.name_seat}
                                            price={price}
                                            invited={el.invited}
                                            dataIndex={key}
                                            changeInvited={this.changeInvited} />
                                    })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="pt-6">
                            <div className="text-center pt-8 pb-6">
                                <Link to='/' style={{ color: '#fff' }} className="btn btn-lg btn-warning">VOLVER AL INICIO</Link>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}

export default connect(getState, Dispatch)(ThankYou);



// WEBPACK FOOTER //
// ./src/Pages/ThankYou/index.js